exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-42cd680a]{scroll-behavior:smooth}.question[data-v-42cd680a]{font-size:13px}", ""]);

// exports
